(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom--contact-page"] && !Shopify.designMode) return;
  try {
    
  /*
   * Shopify Forms renders inside an open shadow root that page CSS cannot reach.
   * Layout rules below target the app's stable ids, names and test ids (never
   * its hashed class names), so field order in the Forms admin does not matter.
   */
  const CONTACT_FORM_STYLES = `
    #app-embed [data-testid="app-router"] { justify-content: stretch; }
    #app-embed [data-testid="app-router"] section { margin: 0; overflow: visible; }
    #app-embed section:has(+ [data-testid="form"]) { display: none; }
    #app-embed [data-testid="form"] {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      column-gap: 23px;
      row-gap: 0;
      padding: 0;
    }
    #app-embed [data-testid="form"] > * { grid-column: 1 / -1; margin-bottom: 16px; }
    #app-embed [data-testid="form"] > :has(+ output) { margin-bottom: 6px; }
    #app-embed [data-testid="form"] output { font-size: 12px; line-height: 16px; }
    #app-embed [data-testid="form"] > :has(> shop-lead-capture) { grid-row: 1; margin-bottom: 0; }
    #app-embed [data-testid="form"] > :has(#first_name) { grid-area: 2 / 1; }
    #app-embed [data-testid="form"] > :has(#first_name) + output { grid-area: 3 / 1; }
    #app-embed [data-testid="form"] > :has(#last_name) { grid-area: 2 / 2; }
    #app-embed [data-testid="form"] > :has(#last_name) + output { grid-area: 3 / 2; }
    #app-embed [data-testid="form"] > :has(#email) { grid-area: 4 / 1; }
    #app-embed [data-testid="form"] > :has(#email) + output { grid-area: 5 / 1; }
    #app-embed [data-testid="form"] > :has(input[name="phone_number"]) {
      grid-area: 4 / 2 / span 2;
      align-self: start;
      grid-template-columns: 72px minmax(0, 1fr);
      gap: 11px;
      width: auto;
    }
    #app-embed [data-testid="form"] > :has(input[name="phone_number"]) output { margin-top: -5px; }
    #app-embed [data-testid="form"] > :has(textarea[name="custom#project_details_comments"]) {
      grid-row: 6;
      margin-top: 2px;
      margin-bottom: 17px;
    }
    #app-embed [data-testid="form"] > :has(textarea[name="custom#project_details_comments"]):has(+ output) { margin-bottom: 6px; }
    #app-embed [data-testid="form"] > :has(textarea[name="custom#project_details_comments"]) + output { grid-row: 7; }
    #app-embed [data-testid="form"] > :has(textarea[name="custom#product_context"]) { display: none; }
    #app-embed input, #app-embed textarea, #app-embed button { box-sizing: border-box; }
    #app-embed input, #app-embed textarea { padding-left: 17px; padding-right: 17px; }
    #app-embed input { height: 50px; }
    #app-embed textarea { height: 98px; }
    #app-embed label { left: 17px; color: var(--form-placeholder-color); }
    #app-embed .phone-country-selector button {
      height: 50px;
      max-height: none;
      padding: 0 13px 0 11px;
    }
    #app-embed #country-selector-value { flex: none; width: auto; overflow: visible; }
    #app-embed #country-selector-value + span { margin: 0; }
    #app-embed #country-selector-dropdown,
    #app-embed div:has(> #country-selector-dropdown) { max-height: 288px !important; }
    #app-embed #country-selector-dropdown { overscroll-behavior: contain; }
    #app-embed [data-testid="btn-form-submit"] {
      grid-row: 8;
      justify-self: start;
      margin-bottom: 0;
      align-items: center;
      width: 235px;
      max-width: 100%;
      height: 42px;
      padding: 0 16px;
      font: normal 700 12px/1 var(--font-heading--family);
      text-transform: uppercase;
    }
    #app-embed [data-testid="form"] ~ div { margin-top: 12px; font-size: 12px; text-align: left; }
    @media (max-width: 599px) {
      #app-embed [data-testid="form"] { grid-template-columns: minmax(0, 1fr); }
      #app-embed [data-testid="form"] > * { grid-column: 1 !important; }
      #app-embed [data-testid="form"] > :has(#first_name) + output { grid-row: 3; }
      #app-embed [data-testid="form"] > :has(#last_name) { grid-row: 4; }
      #app-embed [data-testid="form"] > :has(#last_name) + output { grid-row: 5; }
      #app-embed [data-testid="form"] > :has(#email) { grid-row: 6; }
      #app-embed [data-testid="form"] > :has(#email) + output { grid-row: 7; }
      #app-embed [data-testid="form"] > :has(input[name="phone_number"]) { grid-row: 8; }
      #app-embed [data-testid="form"] > :has(textarea[name="custom#project_details_comments"]) { grid-row: 9; }
      #app-embed [data-testid="form"] > :has(textarea[name="custom#project_details_comments"]) + output { grid-row: 10; }
      #app-embed [data-testid="btn-form-submit"] { grid-row: 11; }
    }
  `;

  class ContactPage extends HTMLElement {
    connectedCallback() {
      this.attempts = 0;
      this.timer = setInterval(() => this.attachToForm(), 100);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    attachToForm() {
      const root = this.querySelector('shopify-forms-embed')?.shadowRoot;
      const app = root?.getElementById('app-embed');
      this.attempts += 1;
      if (!app && this.attempts < 300) return;

      clearInterval(this.timer);
      if (!app) return;

      const style = document.createElement('style');
      style.textContent = CONTACT_FORM_STYLES;
      root.append(style);

      this.keepCountryListOpen(root);
    }

    /*
     * The app closes the country list on any focusout that doesn't land on an
     * option, so grabbing its scrollbar (or padding) used to close it. Letting
     * the list take focus and swallowing focus moves within it keeps it open;
     * leaving the list still closes it.
     */
    keepCountryListOpen(root) {
      root.addEventListener(
        'pointerdown',
        (event) => {
          if (event.target.id === 'country-selector-dropdown') event.target.tabIndex = -1;
        },
        true
      );
      root.addEventListener(
        'focusout',
        (event) => {
          const list = root.getElementById('country-selector-dropdown');
          if (list?.contains(event.target) && list.contains(event.relatedTarget)) event.stopPropagation();
        },
        true
      );
    }
  }

  if (!customElements.get('contact-page')) customElements.define('contact-page', ContactPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
